import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FollowUpResponse } from '../models/FollowUpResponse';

@Injectable({
    providedIn: 'root',
})
export class FollowUpService {
    constructor(private http: HttpClient) {}

    getStudentsFollowUp(): Observable<FollowUpResponse> {
        const url = `/api/v1/users/scores/all`;

        return this.http.get<FollowUpResponse>(url);
    }
}
